<template>
  <v-layout>
    <v-flex
      sm2
      d-flex
    >
      <v-text-field
        v-model="model.search"
        return-object
        clearable
        prepend-icon="search"
        :label="$t($lang.app.SEARCH)"
        @input="filterChanged"
        @change="filterChanged"
      />
    </v-flex>
    <v-flex
      sm2
      d-flex
    >
      <CategoryFilter
        v-model="model.categories"
        @input="filterChanged"
      />
    </v-flex>
    <v-flex
      sm2
      d-flex
    >
      <v-select
        v-model="model.user"
        clearable
        item-value="id"
        item-text="fullName"
        :label="$t($lang.author.AUTHOR)"
        :items="authors"
        @change="filterChanged"
      />
    </v-flex>
    <v-flex
      sm2
      d-flex
    >
      <PhoDatePicker
        range
        clearable
        :label="$t($lang.date.DATE_RANGE)"
        @input="filterDateChanged"
      />
    </v-flex>
    <v-flex
      sm2
      d-flex
    >
      <v-checkbox
        v-model="model.isChiefSelection"
        :label="$t($lang.content.CHEFS_CHOICE)"
        @change="filterChanged"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { filterBase } from 'piri/content-transform';

import { PhoDatePicker } from '@/components/misc/form';
import { CategoryFilter } from '@/components/category';

import getterTypes from '@/api/recipe/store/types/getterTypes';
import actionTypes from '@/api/recipe/store/types/actionTypes';

export default {
  name: 'FilterComponent',
  components: { PhoDatePicker, CategoryFilter },
  extends: filterBase,
  data() {
    return {
      startDate: undefined,
      endDate: undefined,
      model: {
        search: undefined,
        categories: undefined,
        user: undefined,
        date: null,
        issueNumber: undefined,
        isChiefSelection: false,
      },
    };
  },
  computed: {
    authors() {
      return this.$store.getters[getterTypes.AUTHORS];
    },
  },
  mounted() {
    this.$store.dispatch(actionTypes.GET_AUTHORS);

    this.reset = this.resetFilter;
  },
  methods: {
    filterChanged() {
      this.changed();
    },
    filterDateChanged(dateRange) {
      this.model.date = dateRange ? { startDate: dateRange[0], endDate: dateRange[1] } : undefined;

      this.changed();
    },
    resetFilter() {
      this.startDate = null;
      this.endDate = null;
      this.model = {
        search: undefined,
        categories: undefined,
        user: undefined,
        date: null,
        issueNumber: undefined,
        isChiefSelection: false,
      };
    },
  },
};
</script>
